<template>
  <div id="choices">
    <div class="choice">
      <nullable-radio-button 
        :checked="yay"
        :label="labels.yes"
        :loading="loading"
        value="true"
        :name="`${name}Yay`"
        @change="onChange(true)"
      />
    </div>
    <div class="choice">
      <nullable-radio-button 
        :checked="nay"
        :label="labels.no"
        :loading="loading"
        value="false"
        :name="`${name}Nay`"
        @change="onChange(false)"
      />
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import NullableRadioButton from '@atoms/NullableRadioButton';
export default {
  emits: ['change'],
  props: {
    labels: Object,
    loading: Boolean,
    name: String,
  },
  setup(props, {emit}) {
    const choice = ref(null);
    const name = computed(() => props.name);
    const nay = computed(() => choice.value === 'nay' || false);
    const yay = computed(() => choice.value === 'yay' || false);
    const onChange = (e) => {
      choice.value = e ? 'yay' : 'nay'
      emit('change', { name: name.value, value: e });
    }

    return {
      choice,
      nay,
      yay,
      onChange,
    }
  },
  components: {
    NullableRadioButton,
  }
}
</script>